import {getCookie} from '../../../other/utils/cookie.js';

const user = {
    state: {
        user: '',
        token: getCookie("token"),
        roles: [],
        ticket: {},
        hasLogin:false,
        longitude:'',
        latitude:'',
        userInfo:null,
        is_sign_us:0,//1普通用户  2 店主
        shopInfo:null,
        dealer1Info:null,
        dealer2Info:null,
        itemInfo:null,
        codeInfo:null,
        obj1:null,
        obj2:null,
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_USER: (state, name) => {
            state.user = name;
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles;
        },
        SET_TICKET: (state, ticket) => {
            state.ticket = ticket;
        },
        SET_HAS_LOGIN: (state, login) => {
            state.hasLogin = login;
        },
        SET_LONGITUDE: (state, longitude) => {
            state.longitude = longitude;
        },
        SET_LATITUDE: (state, latitude) => {
            state.latitude = latitude;
        },
        SET_USERINFO: (state, userInfo) => {
            state.userInfo = userInfo;
        },
        SET_SIGN: (state, sign) => {
            state.is_sign_us = sign;
        },
    },
    actions: {
         // 获取用户信息
         Login({commit}, login) {
            return new Promise((resolve, reject) => {
                commit('SET_HAS_LOGIN', login);
                resolve();
            });
        },
        // 获取用户信息
        LoginIn({commit}, roles) {
            return new Promise((resolve, reject) => {
                commit('SET_ROLES', roles);
                resolve();
            });
        },
        //ticket写入
        setTicket({commit}, ticket) {
            return new Promise((resolve, reject) => {
                commit('SET_TICKET', ticket);
                resolve();
            })
        },
        setToken({commit}, token) {
            return new Promise((resolve, reject) => {
                commit('SET_TOKEN', token);
                resolve();
            })
        }
    }
};

export default user;



// WEBPACK FOOTER //
// ./src/other/store/modules/user.js